"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var image_1 = require("../../controls/image");
wp.customize.controlConstructor['epsilon-image'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new image_1.EpsilonImage(control);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/extenders/controls/image.ts
// module id = 16
// module chunks = 0